import { render, staticRenderFns } from "./WidgetDescription.vue?vue&type=template&id=f0de51ea&scoped=true&"
import script from "./WidgetDescription.vue?vue&type=script&lang=js&"
export * from "./WidgetDescription.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDescription.vue?vue&type=style&index=0&id=f0de51ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0de51ea",
  null
  
)

export default component.exports